module.exports = __webpack_public_path__ + "static/media/show2.36d8695f.png";